<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="element-wrapper">
            <div class="element-box">
              <div class="st-meta float-right">
                <button type="button" data-toggle="modal" data-target="#modalLog" class="btn btn-info">
                  <i class="fas fa-history"></i>
                  Log transacciónes
                </button>
                &nbsp;
                <div class="btn-group">
                  <div class="dropleft">
                    <button class="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fas fa-cogs"></i> Acciones
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" href="#" @click="imprimirCorte">Imprimir corte de caja <i
                          class="fas fa-print"></i></a>
                      <a @click="imprimirRetiroEfectivo" class="dropdown-item" href="#">Imprimir retiro de efectivo <i
                          class="fas fa-print"></i></a>
                      <a @click="imprimirDetalleVenta" class="dropdown-item" href="#">imprimir detalle de ventas <i
                          class="fas fa-print"></i></a>
                      <a @click="generarPolizaDeCierre" class="dropdown-item" href="#">Generar Poliza de Cierre <i
                          class="fas fa-check"></i></a>
                    </div>
                  </div>
                </div>
              </div>
              <router-link class="btn btn-outline-dark btn-sm" :to="{ name: 'cxc-corte-caja', params: {} }">
                <i class="fa fa-back"></i>
                <i class="fas fa-reply"></i> Volver al Listado
              </router-link>
              <h5 v-if="!current.codigo" class="form-header">
                Información de Corte de Caja
              </h5>
              <div class="row">
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Numero</label>
                    <input v-model="current.numero" class="form-control" autofocus="autofocus" readonly="true" placeholder
                      type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Fecha de Cierre</label>
                    <input v-model="current.fecha_cierre" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Tienda</label>
                    <input v-model="current.tienda" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }"># de Caja</label>
                    <input v-model="current.caja" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Usuario</label>
                    <input v-model="current.usuario" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Factura Serie</label>
                    <input v-model="current.serie_fact" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Recibo Serie</label>
                    <input v-model="current.serie_rc" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        current.errors.codigo &&
                        current.errors.codigo.length > 0,
                    }">Monto de Apertura</label>
                    <input v-model="current.monto_apertura" class="form-control" autofocus="autofocus"
                      :readonly="current.id != null" placeholder type="text" v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }" />
                  </div>
                </div>
              </div>
              <br />
              <div class="alert alert-warning" role="alert">
                <h4 class="alert-heading">Observaciones</h4>
                <p class="text-dark font-weight-bold"></p>
                <h6 class="fas fa-info text-info"></h6>
                <span class="text-dark">
                  Solo se puede modificar el detalle del corte de caja con un
                  maximo de 3 dias despues de la fecha de cierre de caja.
                </span>
                <p class="mb-0"></p>
              </div>
              <br>
              <div class="alert alert-info" role="alert" v-if="current.poliza_cierre">
                <h4 class="alert-heading">Poliza de cierre generada</h4>
              </div>
              <h5 class="form-header">Detalle de Cierre</h5>
              <div class="table-responsive" v-if="current.id != null">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Forma de pago</th>
                      <th>Responsable</th>
                      <th class="text-center">Total</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in current.cxccierredetalle_set" v-bind:key="detalle.id">
                      <td>{{ detalle.forma_pago }}</td>
                      <td>{{ detalle.usuario.name }}</td>
                      <td class="text-right">Q {{ detalle.total }}</td>
                      <td class="text-right">
                        <button @click="eliminarLinea(detalle)" class="btn btn-danger btn-sm">
                          <i class="fas fa-trash"></i> &nbsp; Eliminar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <button :diabled="current.fecha_cierre" type="button" data-toggle="modal"
                  data-target="#modalAgregarDetalleCierre" class="btn btn-secondary btn-md">
                  <i class="fas fa-cash-register"></i>
                  Agregar detalle de cierre
                </button>
                <button type="button" data-toggle="modal" data-target="#exampleModal" class="btn btn-secondary btn-md">
                  <i class="fas fa-cash-register"></i>
                  Agregar detalle de cierre despues de corte
                </button>
                <button type="button" data-toggle="modal" data-target="#exampleModal1" class="btn btn-primary btn-md">
                  <i class="fas fa-hand-holding-usd"></i>
                  Agregar retiro de efectivo
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="modalAgregarDetalleCierre" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Agregar Detalle de Cierre <i class="fas fa-cash-register"></i>
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-12">
                <label>Forma de Pago</label>
                <select type="text" class="form-control" v-model="currentDetalle.forma_pago">
                  <option v-for="(detalle, key) in formas_pago" :value="detalle.id" :key="key">
                    {{ detalle.nombre }}
                  </option>
                </select>
              </div>
              <br />
              <div class="col-12">
                <label>Total</label>
                <input type="text" class="form-control" v-model="currentDetalle.total" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-dark" data-dismiss="modal">
                <i class="fas fa-door-open"></i> Cerrar
              </button>
              <button type="button" @click="agregarDetalleAfter(currentDetalle)" class="btn btn-info">
                <i class="fas fa-save"></i> Guardar Detalle
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal -->
      <!-- Modal -->
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title" id="exampleModalLabel">
                Agregar detalle de cierre despues de corte
                <i class="fas fa-cash-register"></i>
              </h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-12">
                <label>Forma de Pago</label>
                <select type="text" class="form-control" v-model="currentDetalle.forma_pago">
                  <option v-for="(detalle, key) in formas_pago" :value="detalle.id" :key="key">
                    {{ detalle.nombre }}
                  </option>
                </select>
              </div>
              <br />
              <div class="col-12">
                <label>Total</label>
                <input type="text" class="form-control" v-model="currentDetalle.total" />
                <small v-bind:class="{
                  'text-danger':
                    currentDetalle.errors.total &&
                    currentDetalle.errors.total.length > 0,
                }"></small>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-dark" data-dismiss="modal">
                <i class="fas fa-door-open"></i> Cerrar
              </button>
              <button type="button" @click="agregarDetalle(currentDetalle)" class="btn btn-info">
                <i class="fas fa-save"></i> Guardar Detalle
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Agregar retiro de efectivo
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-12">
                <label>Total retiro</label>
                <input type="number" class="form-control" v-model="currentDetalle.total" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cerrar
              </button>
              <button type="button" @click="agregarRetiroEfectivo(currentDetalle)" class="btn btn-primary">
                Guardar Detalle
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="current.id">
      <LogModalComponent modulo="cxc" transac="corte-caja" :id="current.id" />
    </div>
  </div>
</template>

<script>
import CorteCajaService from "@/services/cxc/CorteCajaService";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import LogModalComponent from "@/components/commons/LogModalComponent";

export default {
  components: { LogModalComponent },
  data() {
    return {
      formas_pago: [],
      currentDetalle: {
        agregado_desde_frontend: true,
      },
      currentDetalle: {
        errors: [],
      },
      current: {
        errors: {},
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    if (self.$route.params.id) {
      this.refreshCurrent();
    }
    self.refreshFormasPago();
  },
  methods: {
    refreshCurrent() {
      let self = this;
      CorteCajaService.getById(self.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.serie_fact = response.data.caja.serie_fact;
        self.current.serie_rc = response.data.caja.serie_rc;
        self.current.tienda = response.data.tienda.nombre;
        self.current.caja = response.data.caja.caja;
        self.current.usuario = response.data.usuario.name;
        if (self.current.fecha_cierre) {
          self.current.fecha_cierre = moment(self.current.fecha_cierre).format(
            "DD/MM/YYYY"
          );
        }
        self.current.errors = [];
      });
    },
    refreshFormasPago() {
      DynamicService.fetch("cat", "forma-pago").then((response) => {
        this.formas_pago = response.data.results;
      });
    },
    agregarRetiroEfectivo(currentDetalle) {
      this.currentDetalle.forma_pago = "EFECTIVO";
      DynamicService.postAction(
        "cxc",
        "corte-caja",
        this.current.id,
        "agregar_retiro_efectivo",
        currentDetalle
      )
        .then((response) => {
          Notifications.alert.success(
            "Agregar retiro de efectivo",
            "realizado correctamente"
          );
          this.refreshCurrent();
          $("#exampleModal1").modal("hide");
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Agregar retiro de efectivo",
            errors.response.data.total
          );
        });
    },
    clearDataDetalle() {
      let self = this;
      self.currentDetalle.forma_pago = "";
      self.currentDetalle.total = "";
    },
    agregarDetalle(currentDetalle) {
      DynamicService.postAction(
        "cxc",
        "corte-caja",
        this.current.id,
        "agregar_detalle_despues_cierre",
        currentDetalle
      )
        .then((response) => {
          Notifications.alert.success(
            "Agregar detalle de corte",
            "realizado correctamente"
          );
          this.refreshCurrent();
          this.clearDataDetalle();
          $("#exampleModal").modal("hide");
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Agregar detalle de corte",
            errors.response.data.detail
          );
        });
    },
    agregarDetalleAfter(currentDetalle) {
      DynamicService.postAction(
        "cxc",
        "corte-caja",
        this.current.id,
        "agregar_detalle_cierre",
        currentDetalle
      )
        .then((response) => {
          this.clearDataDetalle();
          Notifications.alert.success(
            "Agregar detalle de corte",
            "realizado correctamente"
          );
          this.refreshCurrent();
          $("#modalAgregarDetalleCierre").modal("hide");
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Agregar detalle de corte",
            errors.response.data.detail
          );
        });
    },
    eliminarLineaAfter(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar linea",
        "¿Esta Seguro?",
        " ",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja",
            self.current.id,
            "eliminar_detalle_cierre",
            detalle
          )
            .then((response) => {
              Notifications.alert.success(
                "eliminar linea",
                "realizado correctamente"
              );
              self.refreshCurrent();
            })
            .catch((errors) => {
              if (errors.response) {
                Notifications.alert.error(
                  "Eliminar Linea",
                  errors.response.data.detail
                );
              }
            });
        }
      );
    },
    eliminarLinea(detalle) {
      let self = this;
      if (!this.current.fecha_cierre) {
        this.eliminarLineaAfter(detalle);
        return;
      }
      Notifications.alert.confirm(
        "Eliminar linea",
        "¿Esta Seguro?",
        " ",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja",
            self.current.id,
            "eliminar_detalle_despues_cierre",
            detalle
          )
            .then((response) => {
              Notifications.alert.success(
                "eliminar linea",
                "realizado correctamente"
              );
              self.refreshCurrent();
            })
            .catch((errors) => {
              if (errors.response) {
                Notifications.alert.error(
                  "Eliminar Linea",
                  errors.response.data.detail
                );
              }
            });
        }
      );
    },
    imprimirCorte() {
      let self = this;
      CorteCajaService.imprimir_corte(self.current.id)
        .then((response) => {
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
    imprimirDetalleVenta() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/DetalleVenta_FormaPago_Caja.jrxml&Id=${self.id}`
      );
    },
    imprimirRetiroEfectivo() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/RetiroEfectivo_media_carta.jrxml&Id=${self.id}`
      );
    },
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, this.current);
      CorteCajaService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Tienda",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cat-tiendas-editar",
            params: { id: self.current.codigo },
          });
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            self.current.errors = error.response.data;
          }
        });
    },
    generarPolizaDeCierre() {
      let self = this;
      Notifications.alert.confirm(
        "Corte de Caja",
        "¿Deseas generar la poliza de cierre de este corte?",
        "Si Generar",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja",
            self.current.id,
            "generar_poliza_de_cierre_caja"
          )
            .then((response) => {
              Notifications.alert.success(
                "Corte de Caja",
                "Poliza de Cierre generada exitosamente"
              );
              this.refreshCurrent();
            })
            .catch((errors) => {
              Notifications.alert.error(
                "Corte de Caja",
                JSON.stringify(errors.response.data)
              );
            });
        }
      );
    },
    hide: function () {
      this.$data.destroy();
    },
  },
};
</script>
